import { Text, Box } from '@chakra-ui/react';
import React from 'react';

interface DashboardCardProps {
  title: string;
  value: string;
  children: React.ReactNode;
  onClick?: () => void;
  /** Selo no canto do card (ex.: "NOVO" num módulo recém-lançado). */
  badge?: string;
}

export const DashboardCard = ({ title, value, children, onClick, badge }: DashboardCardProps) => {
  return (
    <Box
      onClick={onClick}
      position="relative"
      className="flex flex-col items-center gap-4 rounded-3xl border-2 border-solid bg-body p-5 lg:flex-row lg:gap-4"
      cursor="pointer"
      transition="all 0.3s ease"
      _hover={{
        transform: 'translateY(-4px)',
        boxShadow: 'xl',
        borderColor: 'blue.400',
      }}
      _active={{
        transform: 'translateY(-2px)',
      }}
    >
      {badge && (
        <Text
          position="absolute"
          top="10px"
          right="12px"
          px={2}
          borderRadius="full"
          bg="#0077B6"
          color="white"
          fontSize="10px"
          fontWeight="bold"
          letterSpacing="0.08em"
        >
          {badge}
        </Text>
      )}
      <div className="flex-shrink-0">{children}</div>
      <div className="flex w-full flex-col items-center gap-3 lg:items-start lg:pr-1">
        <Text
          fontWeight="bold"
          fontSize={{ base: '15px', md: '16px' }}
          lineHeight="1.3"
          textAlign={{ base: 'center', lg: 'left' }}
        >
          {title}
        </Text>
        {value && (
          <Text
            fontSize={{ base: '13px', md: '14px' }}
            color="gray.600"
            lineHeight="1.4"
            textAlign={{ base: 'center', lg: 'left' }}
          >
            {value}
          </Text>
        )}
      </div>
    </Box>
  );
};
